var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.password)?_c('ul',{staticClass:"password-checklist"},_vm._l((_vm.rules),function(rule){return _c('li',{key:rule.key,class:{ passed: rule.passed }},[_c('i',{class:rule.passed ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" "+_vm._s(rule.label)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }